import type { TFunction } from "i18next";
import type { Provider } from "./models";
import type { BankType } from "./settings";

interface SetupStatusResponse {
  hasSetupComplete: boolean;
  hasBank: boolean;
  hasAddress: boolean;
  hasProvider: boolean;
}

interface CompleteSetupResponse {
  success: boolean;
}

enum Step {
  Bank = "bank",
  Address = "address",
  Provider = "provider",
}

enum BankStepType {
  ASA = "ASA",
  PROCREDIT = "PROCREDIT",
}

interface StepIndicatorProps {
  currentStep: Step;
  t: TFunction<"setup">;
  stepOrder: readonly Step[];
}

interface WizardState {
  currentStep: Step;
  loading: boolean;
  error: string | null;
  success: boolean;
  providers: Provider[];
  selectedAddressId: number | null;
  bankName: string;
  bankType: BankType;
  bankUsername: string;
  bankPassword: string;
  addressName: string;
  selectedProviderId: string;
  providerUsername: string;
  providerPassword: string;
  providerSkipPayment: boolean;
  providerTaxDeduction: boolean;
  providerTaxDeductionAmount: string;
}

interface SetupWizardContextValue extends WizardState {
  setCurrentStep: (step: Step) => void;
  setState: (partial: Partial<WizardState>) => void;
  handleBankSubmit: () => Promise<void>;
  handleAddressSubmit: () => Promise<void>;
  handleProviderSubmit: () => Promise<void>;
  handleSkip: () => Promise<void>;
  t: TFunction<"setup">;
  stepOrder: readonly Step[];
  checkSetupStatus: () => Promise<void>;
}

export {
  BankStepType,
  type CompleteSetupResponse,
  type SetupStatusResponse,
  type SetupWizardContextValue,
  Step,
  type StepIndicatorProps,
  type WizardState,
};
